/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Description_RequiredInputs */

const cs_validation_description_required = /** @type {(inputs: Validation_Description_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popis je povinný`)
};

const en_validation_description_required = /** @type {(inputs: Validation_Description_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description is required`)
};

/**
* | output |
* | --- |
* | "Description is required" |
*
* @param {Validation_Description_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_description_required = /** @type {((inputs?: Validation_Description_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Description_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_description_required(inputs)
	return cs_validation_description_required(inputs)
});